import type {ReactElement} from 'react';
import type {IconShape} from '@Components/icon-v2/icon.types';

export interface TransitionablePanelV2Props {
  panelId: string;
  content: ReactElement | null;
  header: ReactElement<any> | null;
  contentKey: string;
  transitionDirection: TransitionDirection;
  imageURL?: string;
  imageSrcSet?: string;
  imageClassName?: string;
  imageAlt?: string;
  videoURL?: string;
  /** Custom right-column content. When set, takes precedence over imageURL/videoURL. */
  rightColumn?: ReactElement;
  modalId?: string;
  loadingText?: string;
  loadingContent?: ReactElement | null;
  isLoading?: boolean;
  isCloseIconDisabled?: boolean;
  hideCloseIcon?: boolean;
  isScrollable?: boolean;
  closeIconClassName?: string;
  hideSeeMorePill?: boolean;
  animateHeightOnResize?: boolean;
  /** Lets a step settle to any height on arrival, then suppresses shrinking until the next step. */
  growOnlyWithinStep?: boolean;
  closeIconShape?: IconShape;
  onModalClose?: () => void;
}

export enum TransitionDirection {
  FORWARD = 'forward',
  BACKWARD = 'backward',
}
